export default function Cell({ alignment = 'center', children }) {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: alignment,
        alignItems: 'center',
        width: '100%',
        height: '100%',
        transition: 'opacity 0.3s ease'
      }}
    >
      {children}
    </div>
  );
}
